// @flow

import React from 'react';

import AccountInfoContainer from 'app/common/components/AccountInfoContainer';
import HeaderLogo from 'app/viewport/components/Header/HeaderLogo';
import {
  HeaderBlockContainer,
  HeaderBlockHeaderLinks,
  HeaderBlockInnerWrapper,
  HeaderBlockMenuControls,
} from 'app/viewport/components/Header/HeaderBlock';

type Props = {
  isLoggedIn: boolean,
};

const HeaderIFrame = ({ isLoggedIn }: Props) => {
  return (
    <HeaderBlockContainer>
      <HeaderBlockInnerWrapper kind="justify">
        <HeaderBlockMenuControls>
          <HeaderLogo isLoggedIn={isLoggedIn} target="_blank" />
        </HeaderBlockMenuControls>

        <HeaderBlockHeaderLinks kind="padded">
          <AccountInfoContainer />
        </HeaderBlockHeaderLinks>
      </HeaderBlockInnerWrapper>
    </HeaderBlockContainer>
  );
};

export default HeaderIFrame;
